import { GetterTree } from 'vuex';
import { UserState } from './state';

export enum UserGetterTypes {
  INFO = 'INFO',
  APPLICATIONS = 'APPLICATIONS',
  PROFILE_URL = 'PROFILE_URL',
  LOGOUT_URL = 'LOGOUT_URL',
}

export const getters: GetterTree<UserState, {}> = {
  [UserGetterTypes.INFO](state) {
    return state.info;
  },
  [UserGetterTypes.PROFILE_URL](state) {
    return state.profileUrl;
  },
  [UserGetterTypes.LOGOUT_URL](state) {
    return state.logoutUrl;
  },
  [UserGetterTypes.APPLICATIONS](state) {
    if (process.env.VUE_APP_CURRENT_APP_CODE) {
      return (state.allowedApps || []).filter((app) => app.Code !== process.env.VUE_APP_CURRENT_APP_CODE);
    }
    return state.allowedApps;
  },
};
